var openInfoWindow = null;

var initializeBlockMap = function(block){
	// Find all variables that start with mapData_
	for (var key in window) {
		if (key.startsWith('mapData_')) {
			var currentMapData = window[key];
			var mapElement = jQuery('#' + currentMapData.mapElement);
			
			if(!mapElement.length) {
				continue;
			}
			
			var lat = parseFloat(currentMapData.lat);
			var lng = parseFloat(currentMapData.lng);
			var zoom = parseFloat(currentMapData.zoom);
			var markerData = JSON.parse(currentMapData.markers);
			var markers = [];
			
			var map = new google.maps.Map(mapElement[0], {
				center				: {lat: lat, lng: lng},
				zoom				: zoom,
				mapTypeControl		: false,
				scaleControl		: false,
				streetViewControl	: false,
				rotateControl		: false,
				fullscreenControl	: false,
				mapId				: currentMapData.mapID,
				styles  			: currentMapData.jsonStyling
			});

			for(var i=0; i<markerData.length; i++) {
				createMarker(markerData[i], map, markers, currentMapData);
			}

			if(currentMapData.showAll) {
				centerMap(markers, map);
			}
		}
	}
}


//initialize each block on front end
jQuery(document).ready(function(){
	// Initialize once for all maps
	initializeBlockMap();

	// Re-initialize when new content is loaded via AJAX
	jQuery(document).on('ajaxComplete', function(event, xhr, settings) {
		if (settings.data && settings.data.indexOf('action=get_user_cacs') !== -1) {
			initializeBlockMap();
		}
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=map', initializeBlockMap);


function createMarker(markerData, map, markers, currentMapData) {
	
	if(currentMapData.markerIcon) {
	
		var markerWidth = currentMapData.markerWidth;
		var markerHeight = currentMapData.markerHeight;
		var markerDefault = currentMapData.markerIcon;
		//var markerHover = "/wp-content/themes/plumbweb-child/_assets/img/marker-hover.svg";
		
		var marker = new google.maps.Marker({
			map			: map,
			position	: {lat: markerData.lat, lng: markerData.lng},
			icon 		: { 
				url			: markerDefault, 
				size		: new google.maps.Size(markerWidth, markerHeight), 
				scaledSize	: new google.maps.Size(markerWidth, markerHeight)
			}
		});
		
		//marker.addListener('mouseover', function(){
			//marker.setIcon(markerHover);
		//});
		
		//marker.addListener('mouseout', function(){
			//marker.setIcon(markerDefault);
		//});
		
	} else {
	
		var marker = new google.maps.Marker({
			map			: map,
			position	: {lat: markerData.lat, lng: markerData.lng}
		});
		
		var markerHeight = 35;
		
	}
	
	marker.set("html", markerData.html);
	
	marker.addListener('click', function(){
		
		if(openInfoWindow) {
			openInfoWindow.close();
		}
		
		var infowindow = new google.maps.InfoWindow({
			content: marker.get("html"),
			position: {lat: marker.getPosition().lat(), lng: marker.getPosition().lng()},
			pixelOffset: new google.maps.Size(0, -markerHeight - 10)
		});
		
		map.panTo(marker.getPosition());
		
		infowindow.open(map);
		
		openInfoWindow = infowindow;
		
	});
	
	markers.push(marker);
	
}

function centerMap(markers, map){
	
	if(markers.length){
	
		var bounds = new google.maps.LatLngBounds();
		
		for(var i=0; i<markers.length; i++){
			
			bounds.extend({
				lat: markers[i].position.lat(),
				lng: markers[i].position.lng()
			});
			
		}
	
		if(markers.length == 1){
			map.setCenter(bounds.getCenter());
	
		} else{
			map.fitBounds(bounds);
		}
	
	}
	
}
